import { LinearProgress as MuiLinearProgress, LinearProgressProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { LinearProgressProps };

export const LinearProgress: React.ComponentType<LinearProgressProps> = styled(
  MuiLinearProgress,
)<LinearProgressProps>(({ theme }) => ({
  backgroundColor: theme.palette.colors.bg['neutral-secondary-hard'],
  borderRadius: '2px',
}));
